var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 85",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "       M68.9977 63.4141       C71.4736 59.6222 73.1818 55.3791 74.0246 50.9271        74.8674 46.4751 74.8284 41.9014 73.9098 37.4672        72.9912 33.0329 71.2110 28.8249 68.6708 25.0834        66.1306 21.3419 62.8802 18.1401 59.1051 15.6610        51.4810 10.6542 42.1828  8.8947 33.2560 10.7694        24.3291 12.6442 16.5048 17.9996 11.5044 25.6577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1816 29.3844 L9.19604 25.1971"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19604 25.1971 L13.3992 4.13189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2108 75.4222 L55.1689 75.4139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08607 42.0993 L6.04409 42.0910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44691 59.5914 L9.40494 59.5831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0454 72.9860 L21.0034 72.9776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7745 78.8224 L37.7325 78.8140"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.58e37bafb6ef11a3247f6ee70d671f0f.svg";
export { ForwardRef as ReactComponent };